import axios from 'axios';
import { auth } from '../firebase';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeaders = async () => {
  const user = auth.currentUser;
  if (!user) throw new Error('Not authenticated');
  return {
    Authorization: `Bearer ${user.uid}`,
  };
};

export const api = {
  async createCheckIn(text) {
    const headers = await getAuthHeaders();
    const response = await axios.post(`${API}/checkins`, { text }, { headers });
    return response.data;
  },

  async getCheckIns(days = 7) {
    const headers = await getAuthHeaders();
    const response = await axios.get(`${API}/checkins?days=${days}`, { headers });
    return response.data;
  },

  async sendChatMessage(message) {
    const headers = await getAuthHeaders();
    const response = await axios.post(`${API}/chat`, { message }, { headers });
    return response.data;
  },

  async getChatHistory(limit = 50) {
    const headers = await getAuthHeaders();
    const response = await axios.get(`${API}/chat/history?limit=${limit}`, { headers });
    return response.data;
  },

  async getTrends(days = 30) {
    const headers = await getAuthHeaders();
    const response = await axios.get(`${API}/trends?days=${days}`, { headers });
    return response.data;
  },

  async getUserStatus() {
    const headers = await getAuthHeaders();
    const response = await axios.get(`${API}/user/status`, { headers });
    return response.data;
  },
};